import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React, { useRef } from "react";
import { ExtendedNextPage } from "types/pages";
import ReactToPrint from "react-to-print";

import Content from "components/Content";
import Label from "components/Label";
import Button from "components/Button";
import styles from "./styles.module.scss";
import { privacy } from "./constants";

const Privacy: ExtendedNextPage = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={ref} className={styles.container}>
      <Head>
        <title>Privacy policy</title>
        <meta name="about" content="Humming home's privacy policy" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Content contentClassName={styles.terms}>
        <Label className={styles.title} variant="h2-centered" color="primary">
          Privacy Policy
        </Label>
        {ref.current && (
          <ReactToPrint
            content={() => ref.current}
            trigger={() => (
              <Button
                className={styles.print}
                variant="text"
                onClick={() => {}}
              >
                Print privacy policy
              </Button>
            )}
          />
        )}
        <Label color="primary" useMarkdown>
          {privacy}
        </Label>
      </Content>
      <StartHumming fillColor="primary" />
    </div>
  );
};

Privacy.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Privacy;
